"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatReasoning = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/domains/chat/chat-reasoning-flow");
require("@/components/common");
const schedule_controller_1 = require("@/controllers/schedule-controller");
// 생각 중일 때 flow를 하나씩 넘겨 보여주는 간격.
const FLOW_INTERVAL_MS = 2200;
/**
 * AI의 현재 상황만 보여주는 reasoning 컨테이너.
 * 접힘/펼침과 단계형 이력 대신 현재 노출할 flow 하나를 슬롯으로 받습니다.
 *
 * <mm-chat-reasoning thinking>
 *   <mm-chat-reasoning-flow label="관련 자료 탐색">토큰 파일 검색 중</mm-chat-reasoning-flow>
 * </mm-chat-reasoning>
 */
let ChatReasoning = class ChatReasoning extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.thinking = false;
        this.duration = '';
        this.flowIndex = 0;
        this.flowRotation = new schedule_controller_1.ScheduleController(this, () => this.showNextFlow(), {
            delay: FLOW_INTERVAL_MS,
        });
        this.handleFlowSlotChange = () => {
            this.flowRotation.cancel();
            const flows = this.getFlows();
            if (!flows.length)
                return;
            if (this.flowIndex >= flows.length)
                this.flowIndex = 0;
            this.activateFlow(flows);
            if (!this.thinking || flows.length < 2)
                return;
            this.flowRotation.request();
        };
    }
    // role="status"는 암묵적으로 aria-live="polite"라 따로 두지 않는다.
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'status');
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderDuration()}
      <span>
        <slot @slotchange=${this.handleFlowSlotChange}></slot>
      </span>
    `;
    }
    renderDuration() {
        if (!this.duration)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size="12" color="light">${this.duration}</mm-text>
    `;
    }
    firstUpdated() {
        this.handleFlowSlotChange();
    }
    updated(changed) {
        if (changed.has('thinking'))
            this.handleFlowSlotChange();
    }
    getFlows() {
        return this.assignedFlows.filter(flow => !flow.hidden);
    }
    // 다음 차례를 먼저 다시 예약해, 생각하는 동안 일정한 간격으로 계속 넘긴다.
    showNextFlow() {
        this.flowRotation.request();
        const flows = this.getFlows();
        if (!flows.length)
            return;
        this.flowIndex = (this.flowIndex + 1) % flows.length;
        this.activateFlow(flows);
    }
    activateFlow(flows) {
        flows.forEach((flow, index) => {
            flow.active = index === this.flowIndex;
        });
    }
};
ChatReasoning.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    ::slotted(mm-chat-reasoning-flow) {
      grid-area: 1 / 1;
      opacity: 0;
      pointer-events: none;
      transform: translateY(var(--space-1));
      transition: opacity var(--transition-duration) var(--transition-easing),
        transform var(--transition-duration) var(--transition-easing);
    }

    ::slotted(mm-chat-reasoning-flow[active]) {
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], ChatReasoning.prototype, "thinking", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatReasoning.prototype, "duration", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ selector: 'mm-chat-reasoning-flow', flatten: true })
], ChatReasoning.prototype, "assignedFlows", void 0);
ChatReasoning = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-reasoning')
], ChatReasoning);
exports.ChatReasoning = ChatReasoning;
//# sourceMappingURL=data:application/json;base64,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